/**
 * Car Kits Finder - Interactive UI for slideshow car kits finder block
 * Handles color selection, type selection, and navigation to filtered collections
 */

console.log('🚗 Car Kits Finder: Script loaded successfully!');

// Initialize function
function initializeAllFinders() {
  console.log('🚗 Car Kits Finder: Initializing...');
  const finders = document.querySelectorAll('.kits-finder');
  console.log('🚗 Car Kits Finder: Found', finders.length, 'kits finders');
  
  if (finders.length === 0) {
    console.log('🚗 Car Kits Finder: No .kits-finder elements found on page');
    console.log('🚗 Car Kits Finder: Available elements with "kits" in class:', document.querySelectorAll('[class*="kits"]'));
  }
  
  finders.forEach((finder, index) => {
    console.log('🚗 Car Kits Finder: Initializing finder', index + 1, finder);
    initKitsFinder(finder);
  });
}

// Initialize immediately if DOM is already loaded, otherwise wait for DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAllFinders);
} else {
  // DOM is already ready, initialize immediately
  initializeAllFinders();
}

// Listen for slider changes to sync finder state
document.addEventListener('sliderChanged', function(event) {
  if (event.detail && event.detail.currentElement) {
    const finder = event.detail.currentElement.querySelector('.kits-finder');
    if (finder) {
      syncFinderState(finder);
    }
  }
});

/**
 * Initialize a car kits finder
 * @param {HTMLElement} root - The .kits-finder element
 */
function initKitsFinder(root) {
  if (!root) {
    console.log('🚗 No root element provided');
    return;
  }

  console.log('🚗 Initializing kits finder on:', root);

  // Get configuration from data attributes
  const config = {
    filterField: root.dataset.filterField || 'color',
    colorMode: root.dataset.colorMode || 'auto',
    typeMode: root.dataset.typeMode || 'dropdown',
    peelableUrl: root.dataset.peelableUrl || '',
    permanentUrl: root.dataset.permanentUrl || '',
    detectedColors: root.dataset.detectedColors || '',
    fallbackColors: root.dataset.fallbackColors || 'Black,Blue,ColorShift,Colorshift,Copper/Bronze,Gold,Green,Grey,HyperShift,Orange,Pink,Purple,Red,Silver/Grey,Tan/Brown,Teal,White,Yellow',
    useSmartDetection: root.dataset.useSmartDetection === 'true',
    // Individual GID settings
    blackGid: root.dataset.blackGid || '',
    blueGid: root.dataset.blueGid || '',
    colorshiftGid: root.dataset.colorshiftGid || '',
    colorshift2Gid: root.dataset.colorshift2Gid || '',
    copperBronzeGid: root.dataset.copperBronzeGid || '',
    goldGid: root.dataset.goldGid || '',
    greenGid: root.dataset.greenGid || '',
    greyGid: root.dataset.greyGid || '',
    hypershiftGid: root.dataset.hypershiftGid || '',
    orangeGid: root.dataset.orangeGid || '',
    pinkGid: root.dataset.pinkGid || '',
    purpleGid: root.dataset.purpleGid || '',
    redGid: root.dataset.redGid || '',
    silverGreyGid: root.dataset.silverGreyGid || '',
    tanBrownGid: root.dataset.tanBrownGid || '',
    tealGid: root.dataset.tealGid || '',
    whiteGid: root.dataset.whiteGid || '',
    yellowGid: root.dataset.yellowGid || ''
  };

  // Debug logging
  console.log('Kits Finder Config:', {
    detectedColors: config.detectedColors,
    useSmartDetection: config.useSmartDetection,
    filterField: config.filterField
  });

  // If smart detection is enabled but no colors found, fall back to manual list
  if (config.useSmartDetection && !config.detectedColors) {
    console.log('🚗 Car Kits Finder: Smart detection enabled but no colors found, using fallback');
  }

  // State management
  const state = {
    color: null,
    colorGid: null,
    type: null
  };

  // Get DOM elements
  const colorSelect = root.querySelector('.kits-finder__color-select');
  const swatchesContainer = root.querySelector('.facet-display');
  const typeButtons = root.querySelectorAll('.kits-finder__type-btn');
  const typeSelect = root.querySelector('.kits-finder__type-select');
  const goButton = root.querySelector('.kits-finder__go');
  const helpText = root.querySelector('.kits-finder__help');

  // Setup UI based on configuration
  setupColorControls(root, config.colorMode, colorSelect, swatchesContainer);
  setupTypeControls(root, config.typeMode, typeButtons, typeSelect, config);

  // Add event listeners
  setupEventListeners(root, state, config, {
    colorSelect,
    swatchesContainer,
    typeButtons,
    typeSelect,
    goButton,
    helpText
  });

  // Initial state update
  updateGoButton(goButton, state, config);
}

/**
 * Get available colors (same for both types now)
 */
function getAvailableColors(type, config) {
  if (config.detectedColors) {
    return config.detectedColors;
  }
  return config.fallbackColors;
}

/**
 * Get the GID for a color name based on type
 */
function getColorGid(colorName, type, config) {
  console.log('getColorGid called:', { colorName, type, useSmartDetection: config.useSmartDetection });
  
  // Map color names to GIDs (same for both types now)
  const colorGidMap = {
    'Black': config.blackGid,
    'Blue': config.blueGid,
    'ColorShift': config.colorshiftGid,
    'Colorshift': config.colorshift2Gid,
    'Copper/Bronze': config.copperBronzeGid,
    'Gold': config.goldGid,
    'Green': config.greenGid,
    'Grey': config.greyGid,
    'HyperShift': config.hypershiftGid,
    'Orange': config.orangeGid,
    'Pink': config.pinkGid,
    'Purple': config.purpleGid,
    'Red': config.redGid,
    'Silver/Grey': config.silverGreyGid,
    'Tan/Brown': config.tanBrownGid,
    'Teal': config.tealGid,
    'White': config.whiteGid,
    'Yellow': config.yellowGid
  };
  
  const gid = colorGidMap[colorName];
  if (gid && gid !== '') {
    console.log('Using mapped GID:', gid);
    return gid;
  } else {
    console.log('No GID mapping found for:', { colorName, availableMappings: Object.keys(colorGidMap) });
  }
  
  // If no GID mapping found, check if it's already a GID
  if (colorName.startsWith('gid://')) {
    console.log('Color is already a GID:', colorName);
    return colorName;
  }
  
  // Fallback: return the color name directly
  console.log('Fallback - returning color name directly:', colorName);
  return colorName;
}

/**
 * Setup color controls based on mode
 */
function setupColorControls(root, colorMode, colorSelect, swatches) {
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  
  // Only handle responsive changes for auto mode
  if (colorMode === 'auto') {
    const swatchesContainer = root.querySelector('.facet-display');
    
    // Handle responsive changes
    const mediaQuery = window.matchMedia('(max-width: 749px)');
    const updateDisplay = function(mq) {
      if (colorSelect) {
        colorSelect.style.display = mq.matches ? 'block' : 'none';
      }
      if (swatchesContainer) {
        swatchesContainer.style.display = mq.matches ? 'none' : 'flex';
      }
    };
    
    // Set initial state
    updateDisplay(mediaQuery);
    
    // Listen for changes
    mediaQuery.addListener(updateDisplay);
  }
}

/**
 * Setup type controls based on mode
 */
function setupTypeControls(root, typeMode, typeButtons, typeSelect, config) {
  // Since we always show the dropdown now, just ensure it's visible
  const selectContainer = root.querySelector('.kits-finder__type--select');
  if (selectContainer) {
    selectContainer.style.display = 'block';
  }

  // Initially disable type selection until color is chosen
  if (typeSelect) {
    typeSelect.disabled = true;
    typeSelect.style.opacity = '0.5';
    typeSelect.style.pointerEvents = 'none';
  }

  if (typeButtons) {
    typeButtons.forEach(button => {
      button.disabled = true;
      button.style.opacity = '0.5';
      button.style.pointerEvents = 'none';
    });
  }

  // Initially disable custom type dropdown
  const typeDropdown = root.querySelector('.kits-finder__type-dropdown');
  if (typeDropdown) {
    const trigger = typeDropdown.querySelector('.kits-finder__dropdown-trigger');
    if (trigger) {
      trigger.style.opacity = '0.5';
      // Don't use pointer-events: none, we need to capture clicks for tooltip
      trigger.setAttribute('data-disabled', 'true');
    }
  }
}

/**
 * Enable type selection controls
 */
function enableTypeSelection(root) {
  // Enable native select
  const typeSelect = root.querySelector('.kits-finder__type-select');
  if (typeSelect) {
    typeSelect.disabled = false;
    typeSelect.style.opacity = '1';
    typeSelect.style.pointerEvents = 'auto';
    // Mark as enabled to show glass effect
    typeSelect.setAttribute('data-enabled', 'true');
  }

  // Enable type buttons
  const typeButtons = root.querySelectorAll('.kits-finder__type-btn');
  if (typeButtons) {
    typeButtons.forEach(button => {
      button.disabled = false;
      button.style.opacity = '1';
      button.style.pointerEvents = 'auto';
    });
  }

  // Enable custom type dropdown
  const typeDropdown = root.querySelector('.kits-finder__type-dropdown');
  if (typeDropdown) {
    const trigger = typeDropdown.querySelector('.kits-finder__dropdown-trigger');
    if (trigger) {
      trigger.style.opacity = '1';
      trigger.removeAttribute('data-disabled');
      // Mark as enabled to show glass effect
      trigger.setAttribute('data-enabled', 'true');
    }
  }
}

/**
 * Setup event listeners for all controls
 */
function setupEventListeners(root, state, config, elements) {
  const { colorSelect, swatchesContainer, typeButtons, typeSelect, goButton, helpText } = elements;

  // Color selection events
  if (colorSelect) {
    colorSelect.addEventListener('change', function() {
      state.color = this.value;
      
      // Track color selection
      if (window.DYCAnalytics) {
        window.DYCAnalytics.trackCustom('car_kits_finder', 'color_selected', state.color);
      }
      
      // Enable type selection now that color is chosen
      enableTypeSelection(root);
      
      updateGoButton(goButton, state, config);
      updateHelpText(helpText, state);
    });
  }

  // Handle swatch events - use event delegation for the facet structure
  if (swatchesContainer) {
    // Handle radio input changes
    swatchesContainer.addEventListener('change', function(event) {
      const input = event.target;
      if (input.type === 'radio' && input.name.includes('kits-color')) {
        // Update state with both color name and GID
        state.color = input.value;
        state.colorGid = input.dataset.gid;
        
        // Track color selection
        if (window.DYCAnalytics) {
          window.DYCAnalytics.trackCustom('car_kits_finder', 'color_selected', state.color);
        }
        
        // Enable type selection now that color is chosen
        enableTypeSelection(root);
        
        updateGoButton(goButton, state, config);
        updateHelpText(helpText, state);
      }
    });
    
    // Handle clicks on the visual swatch
    swatchesContainer.addEventListener('click', function(event) {
      const label = event.target.closest('.facet-checkbox');
      if (label) {
        const input = label.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
          // Force the change event to fire
          const changeEvent = new Event('change', { bubbles: true });
          input.dispatchEvent(changeEvent);
        }
      }
    });
  }

  // Type selection events
  if (typeButtons) {
    typeButtons.forEach(button => {
      button.addEventListener('click', function() {
        if (this.disabled) return;
        
        // Update active state
        typeButtons.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        
        state.type = this.dataset.type;
        
        // Track type selection
        if (window.DYCAnalytics) {
          window.DYCAnalytics.trackCustom('car_kits_finder', 'type_selected', state.type);
        }
        
        updateGoButton(goButton, state, config);
        updateHelpText(helpText, state);
      });
    });
  }

  if (typeSelect) {
    typeSelect.addEventListener('change', function() {
      state.type = this.value;
      
      // Track type selection
      if (window.DYCAnalytics) {
        window.DYCAnalytics.trackCustom('car_kits_finder', 'type_selected', state.type);
      }
      
      updateGoButton(goButton, state, config);
      updateHelpText(helpText, state);
    });
  }

  // Go button click
  if (goButton) {
    goButton.addEventListener('click', function(e) {
      if (this.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        return;
      }
      
      // Track GO button click with full selection
      if (window.DYCAnalytics) {
        window.DYCAnalytics.trackCustom('car_kits_finder', 'go_clicked', `${state.color} - ${state.type}`, 1);
      }
      
      // Let the link navigate naturally
    });
  }

  // Setup custom dropdowns
  setupCustomDropdowns(root, state, config, goButton, helpText);
}

/**
 * Update the GO button state and styling
 */
function updateGoButton(goButton, state, config) {
  if (!goButton) return;

  const isReady = state.color && state.type;
  
  if (isReady) {
    goButton.removeAttribute('aria-disabled');
    goButton.style.pointerEvents = 'auto';
    goButton.style.opacity = '1';
    
    // Build URL using configured collection and filter
    const baseUrl = state.type === 'Peelable' ? config.peelableUrl : config.permanentUrl;
    const colorValue = state.colorGid || getColorGid(state.color, state.type, config);
    
    // Special handling for ColorShift - include both ColorShift and HyperShift in filter
    let finalUrl;
    if (state.color === 'ColorShift') {
      const colorShiftGid = config.colorshiftGid;
      const hyperShiftGid = config.hypershiftGid;
      const filter1 = `filter.p.m.custom.${config.filterField}=${encodeURIComponent(colorShiftGid)}`;
      const filter2 = `filter.p.m.custom.${config.filterField}=${encodeURIComponent(hyperShiftGid)}`;
      finalUrl = `${baseUrl}?${filter1}&${filter2}`;
      console.log('🚗 ColorShift selected - filtering by both ColorShift and HyperShift:', finalUrl);
    } else {
      // Normal single color filter
      const filter = `filter.p.m.custom.${config.filterField}=${encodeURIComponent(colorValue)}`;
      finalUrl = `${baseUrl}?${filter}`;
    }
    
    goButton.href = finalUrl;
    
    // Apply theme colors
    if (state.type === 'Peelable') {
      goButton.style.setProperty('--go-bg', 'var(--peelable-bg)');
      goButton.style.setProperty('--go-fg', 'var(--peelable-fg)');
    } else if (state.type === 'Permanent') {
      goButton.style.setProperty('--go-bg', 'var(--permanent-bg)');
      goButton.style.setProperty('--go-fg', 'var(--permanent-fg)');
    }
  } else {
    goButton.setAttribute('aria-disabled', 'true');
    goButton.style.pointerEvents = 'none';
    goButton.style.opacity = '0.5';
    goButton.href = '#';
  }
}

/**
 * Update help text for accessibility
 */
function updateHelpText(helpText, state) {
  if (!helpText) return;

  if (state.color && state.type) {
    helpText.textContent = `Go to ${state.type} car kits filtered by ${state.color}`;
  } else {
    helpText.textContent = '';
  }
}

/**
 * Sync finder state when slider changes
 */
function syncFinderState(finder) {
  // Reset state when slide becomes active
  const state = {
    color: null,
    type: null
  };

  // Reset UI elements
  const colorSelect = finder.querySelector('.kits-finder__color-select');
  const swatches = finder.querySelectorAll('.kits-finder__swatch');
  const typeButtons = finder.querySelectorAll('.kits-finder__type-btn');
  const typeSelect = finder.querySelector('.kits-finder__type-select');
  const goButton = finder.querySelector('.kits-finder__go');
  const helpText = finder.querySelector('.kits-finder__help');

  if (colorSelect) colorSelect.value = '';
  if (swatches) {
    swatches.forEach(swatch => swatch.setAttribute('aria-pressed', 'false'));
  }
  if (typeButtons) {
    typeButtons.forEach(button => button.classList.remove('active'));
  }
  if (typeSelect) typeSelect.value = '';

  // Get config and update button
  const config = {
    peelableField: finder.dataset.peelableField || 'pearl_color',
    permanentField: finder.dataset.permanentField || 'color',
    peelableUrl: finder.dataset.peelableUrl || '',
    permanentUrl: finder.dataset.permanentUrl || ''
  };

  updateGoButton(goButton, state, config);
  updateHelpText(helpText, state);
}

/**
 * Show tooltip when disabled dropdown is clicked
 */
function showDisabledTooltip(trigger) {
  console.log('🚗 showDisabledTooltip called', trigger);
  
  // Check if tooltip already exists
  let tooltip = document.querySelector('.kits-finder__disabled-tooltip');
  
  if (!tooltip) {
    console.log('🚗 Creating new tooltip');
    // Create tooltip element
    tooltip = document.createElement('div');
    tooltip.className = 'kits-finder__disabled-tooltip';
    tooltip.textContent = 'Pick a color first';
    document.body.appendChild(tooltip);
    
    // Position tooltip above the trigger
    const rect = trigger.getBoundingClientRect();
    tooltip.style.left = rect.left + (rect.width / 2) + 'px';
    tooltip.style.top = rect.top - 8 + 'px';
    
    console.log('🚗 Tooltip created and appended', tooltip);
    
    // Force reflow to trigger animation
    tooltip.offsetHeight;
    
    // Show tooltip
    tooltip.classList.add('show');
    console.log('🚗 Tooltip show class added');
    
    // Hide after 2 seconds
    setTimeout(function() {
      console.log('🚗 Hiding tooltip');
      tooltip.classList.remove('show');
      // Remove from DOM after animation completes
      setTimeout(function() {
        if (tooltip.parentNode) {
          console.log('🚗 Removing tooltip from DOM');
          tooltip.parentNode.removeChild(tooltip);
        }
      }, 300);
    }, 2000);
  } else {
    console.log('🚗 Tooltip already exists, re-showing');
    // If tooltip exists but is hidden, reposition and show it again
    const rect = trigger.getBoundingClientRect();
    tooltip.style.left = rect.left + (rect.width / 2) + 'px';
    tooltip.style.top = rect.top - 8 + 'px';
    
    tooltip.classList.remove('show');
    tooltip.offsetHeight; // Force reflow
    tooltip.classList.add('show');
  }
}

/**
 * Setup custom dropdown functionality
 */
function setupCustomDropdowns(root, state, config, goButton, helpText) {
  // Find all custom dropdowns
  const dropdowns = root.querySelectorAll('.kits-finder__dropdown');
  
  dropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('.kits-finder__dropdown-trigger');
    const options = dropdown.querySelector('.kits-finder__dropdown-options');
    const optionItems = dropdown.querySelectorAll('.kits-finder__dropdown-option');
    
    console.log('🚗 Setting up dropdown:', {
      trigger: !!trigger,
      options: !!options,
      optionCount: optionItems.length,
      optionTexts: Array.from(optionItems).map(opt => opt.textContent.trim())
    });
    
    if (!trigger || !options) return;
    
    // Remove loading state now that dropdown is initialized
    trigger.removeAttribute('data-loading');
    console.log('🚗 Dropdown initialized, loading state removed');
    
    // Move dropdown options to body on first click to escape overflow clipping
    let optionsMovedToBody = false;
    
    // Toggle dropdown - using click event which works on both desktop and mobile
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Check if dropdown is still loading (shouldn't happen, but safety check)
      if (trigger.getAttribute('data-loading') === 'true') {
        console.log('🚗 Dropdown is still loading, ignoring click');
        return;
      }
      
      // Check if dropdown is disabled (for type dropdown before color selection)
      if (trigger.getAttribute('data-disabled') === 'true') {
        console.log('🚗 Dropdown is disabled, ignoring click');
        // Show tooltip
        showDisabledTooltip(trigger);
        return;
      }
      
      const isOpen = dropdown.classList.contains('open');
      
      console.log('🚗 Dropdown clicked, isOpen:', isOpen, 'options count:', optionItems.length);
      
      // Close all other dropdowns
      root.querySelectorAll('.kits-finder__dropdown.open').forEach(otherDropdown => {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('open');
        }
      });
      
      // Toggle current dropdown
      dropdown.classList.toggle('open', !isOpen);
      
      // Move options to body and position it if opening
      if (!isOpen) {
        if (!optionsMovedToBody) {
          document.body.appendChild(options);
          // Store reference to parent dropdown and options for later lookup
          dropdown._dropdownOptions = options;
          options._parentDropdown = dropdown;
          optionsMovedToBody = true;
          console.log('🚗 Moved dropdown options to body');
        }
        
        // Lock body scroll on BOTH mobile AND desktop BEFORE positioning (prevents jump and scroll)
        // Android-safe: use overflow:hidden only, no position:fixed + top manipulation
        if (!document.body.hasAttribute('scroll-locked')) {
          const scrollY = window.scrollY;
          document.body.dataset.scrollY = scrollY;
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
          document.body.setAttribute('scroll-locked', 'true');
        }
        
        // Position the options relative to the trigger
        // Use requestAnimationFrame to ensure layout is complete (iOS Safari fix)
        requestAnimationFrame(() => {
          const rect = trigger.getBoundingClientRect();
          options.style.position = 'fixed';
          // Position exactly at bottom edge (trigger bottom border is transparent when open)
          options.style.top = rect.bottom + 'px';
          options.style.left = rect.left + 'px';
          // Set width with !important priority via cssText to ensure it matches trigger exactly
          options.style.setProperty('width', rect.width + 'px', 'important');
          console.log('🚗 Positioned dropdown:', { top: rect.bottom, left: rect.left, width: rect.width });
        });
        
      // Add open class to options since it's no longer a child of dropdown
      options.classList.add('open');
    } else {
      // Remove open class when closing
      options.classList.remove('open');
      
      // Unlock body scroll when closing (only if no other dropdowns are open)
      // Android-safe: use overflow only, no position manipulation
      const hasOpenDropdowns = root.querySelectorAll('.kits-finder__dropdown.open').length > 0;
      if (!hasOpenDropdowns && document.body.hasAttribute('scroll-locked')) {
        const scrollY = document.body.dataset.scrollY;
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.removeAttribute('scroll-locked');
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
          delete document.body.dataset.scrollY;
        }
      }
    }
    
    // Add/remove class to parent kits-finder for hiding other elements
    if (!isOpen) {
      root.classList.add('dropdown-open');
      console.log('🚗 Dropdown opened, options should be visible');
    } else {
      root.classList.remove('dropdown-open');
      console.log('🚗 Dropdown closed');
    }
  });
    
    // Handle option selection
    optionItems.forEach(option => {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const value = this.dataset.value;
        const text = this.textContent.trim();
        
        // Update trigger text and swatch
        const triggerText = trigger.querySelector('.kits-finder__dropdown-text');
        if (triggerText) {
          // For color dropdown, include the swatch
          if (dropdown.classList.contains('kits-finder__color-dropdown')) {
            const swatchHtml = this.querySelector('.dropdown-option-swatch');
            if (swatchHtml) {
              triggerText.innerHTML = swatchHtml.outerHTML + '<span>' + text + '</span>';
            } else {
              triggerText.textContent = text;
            }
          } else {
            triggerText.textContent = text;
          }
        }
        
        // Update selected state
        optionItems.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');
        
        // Update state based on dropdown type
        if (dropdown.classList.contains('kits-finder__color-dropdown')) {
          state.color = value;
          state.colorGid = this.dataset.gid; // Store GID from dropdown option
          console.log('🚗 Custom color selected:', value, 'GID:', state.colorGid);
          
          // Track color selection
          if (window.DYCAnalytics) {
            window.DYCAnalytics.trackCustom('car_kits_finder', 'color_selected', value);
          }
          
          // Enable type selection now that color is chosen
          enableTypeSelection(root);
        } else if (dropdown.classList.contains('kits-finder__type-dropdown')) {
          state.type = value;
          console.log('🚗 Custom type selected:', value);
          
          // Track type selection
          if (window.DYCAnalytics) {
            window.DYCAnalytics.trackCustom('car_kits_finder', 'type_selected', value);
          }
        }
        
      // Close dropdown
      dropdown.classList.remove('open');
      options.classList.remove('open');
      root.classList.remove('dropdown-open');
      
      // Unlock body scroll when closing (only if no other dropdowns are open)
      // Android-safe: use overflow only
      const hasOpenDropdowns = root.querySelectorAll('.kits-finder__dropdown.open').length > 0;
      if (!hasOpenDropdowns && document.body.hasAttribute('scroll-locked')) {
        const scrollY = document.body.dataset.scrollY;
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.removeAttribute('scroll-locked');
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
          delete document.body.dataset.scrollY;
        }
      }

      // Update UI
      updateGoButton(goButton, state, config);
      updateHelpText(helpText, state);
      });
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    // Check if click is outside root AND outside any dropdown options in body
    const clickedDropdownOption = e.target.closest('.kits-finder__dropdown-options');
    if (!root.contains(e.target) && !clickedDropdownOption) {
      root.querySelectorAll('.kits-finder__dropdown.open').forEach(dropdown => {
        dropdown.classList.remove('open');
        // Also remove open class from options if they're in body
        const options = dropdown.querySelector('.kits-finder__dropdown-options');
        if (options) {
          options.classList.remove('open');
        }
      });
      // Also close any orphaned dropdown options in body
      document.querySelectorAll('.kits-finder__dropdown-options.open').forEach(options => {
        options.classList.remove('open');
      });
      root.classList.remove('dropdown-open');
      
      // Unlock body scroll when closing (only if no other dropdowns are open)
      // Android-safe: use overflow only
      const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
      if (!hasOpenDropdowns && document.body.hasAttribute('scroll-locked')) {
        const scrollY = document.body.dataset.scrollY;
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.removeAttribute('scroll-locked');
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
          delete document.body.dataset.scrollY;
        }
      }
    }
  });

  // Reposition dropdowns on orientation change only
  let repositionFrame = null;
  
  function repositionDropdowns() {
    // Cancel any pending frame to avoid stacking
    if (repositionFrame) {
      cancelAnimationFrame(repositionFrame);
    }
    
    repositionFrame = requestAnimationFrame(() => {
      root.querySelectorAll('.kits-finder__dropdown.open').forEach(dropdown => {
        const trigger = dropdown.querySelector('.kits-finder__dropdown-trigger');
        // Use stored reference instead of querySelector since options are in body
        const options = dropdown._dropdownOptions;
        if (trigger && options && options.parentElement === document.body) {
          const rect = trigger.getBoundingClientRect();
          // Position exactly at bottom edge (trigger bottom border is transparent when open)
          options.style.top = rect.bottom + 'px';
          options.style.left = rect.left + 'px';
          // Set width with !important priority to ensure it matches trigger exactly
          options.style.setProperty('width', rect.width + 'px', 'important');
        }
      });
      repositionFrame = null;
    });
  }
  
  // Reposition on orientation change
  window.addEventListener('orientationchange', repositionDropdowns, { passive: true });
}

// Global ESC key listener to close ALL car kit finder dropdowns
// This runs once globally, not per-instance
if (!window.carKitsFinderEscListener) {
  window.carKitsFinderEscListener = function(e) {
    if (e.key === 'Escape') {
      const openDropdowns = document.querySelectorAll('.kits-finder__dropdown.open');
      if (openDropdowns.length > 0) {
        e.preventDefault();
        openDropdowns.forEach(dropdown => {
          dropdown.classList.remove('open');
          // Use stored reference to find options
          const options = dropdown._dropdownOptions;
          if (options) {
            options.classList.remove('open');
          }
          // Also remove dropdown-open class from parent kits-finder
          const parentFinder = dropdown.closest('.kits-finder');
          if (parentFinder) {
            parentFinder.classList.remove('dropdown-open');
          }
        });
        
        // Unlock body scroll when closing
        // Android-safe: use overflow only
        const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
        if (!hasOpenDropdowns && document.body.hasAttribute('scroll-locked')) {
          const scrollY = document.body.dataset.scrollY;
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
          document.body.removeAttribute('scroll-locked');
          if (scrollY) {
            window.scrollTo(0, parseInt(scrollY));
            delete document.body.dataset.scrollY;
          }
        }
      }
    }
  };
  document.addEventListener('keydown', window.carKitsFinderEscListener);
}

// Export for potential external use
window.initKitsFinder = initKitsFinder;
